import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Flow} from "../../../flows/Flow.js";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../Messages";
import {PaymentMethodAcceptOrChange} from "../payment-method/components/PaymentMethodAcceptOrChange.jsx";
import {AddPaymentMethodComponent} from "../payment-method/components/AddPaymentMethodComponent.jsx";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {AddNewOrLoadCardComponent} from "../payment-method/components/AddNewOrLoadCardComponent";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";


export class PaymentAndDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    paymentDetailsSection = {
        marginBottom: 24,
    };
}

@registerStyle(PaymentAndDonationPanelStyle)
export class PaymentAndDonationPanel extends BasePanelPage {
    forceAddCard = false;
    allowRedraw = true; // TODO @flow2 remove this?

    isButtonDisabled() {
        return !Flow.donationDetails.isValid() || !this.paymentMethodInput?.isValid();
    }

    @wrapInSpinner
    async donate() {
        this.allowRedraw = false;

        const paymentMethod = await this.paymentMethodInput.getPaymentMethod();

        Flow.paymentMethod.update({selectedValue: paymentMethod});

        await Flow.paymentAndDonationDetails.updateAndResolve();

        this.allowRedraw = true;
        this.redraw();
    }

    redraw() {
        if (this.allowRedraw) {
            super.redraw();
        }
    }

    renderExistingPaymentMethodInput() {
        if (iFrameMerchantService.isCDSPaymentMethod()) {
            // Don't allow reusing for TNR for now
            return null;
        }

        if (Flow.paymentMethod.selectedValue) {
            return <PaymentMethodAcceptOrChange ref="paymentMethodInput"/>
        }

        // TODO @cleanup test or remove this complexity
        // Maybe a payment method can be unlocked from a first party cookie access
        const firstPartyPaymentMethodsExist = (iFrameUserDataService.getExtraPaymentMethodCount() > 0 && !this.forceAddCard);

        return firstPartyPaymentMethodsExist && <AddNewOrLoadCardComponent
            onAddCard={() => {
                this.forceAddCard = true;
                this.redraw();
            }}/>;
    }

    renderPaymentMethodInput() {
        // Either we can pay with an existing payment method, or just show a new payment method input
        return this.renderExistingPaymentMethodInput() || <AddPaymentMethodComponent ref="paymentMethodInput" onChange={() => this.redraw()}/>;
    }

    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.paymentDetailsSection}>
                <div className={styleSheet.title}>{Messages.paymentDetails}</div>
                {this.renderPaymentMethodInput()}
            </div>,
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,

            // TODO We use the label as string because of a weird safari bug where the first click isn't perceived.
            <MerchantButton
                label={Flow.donationDetails.getDonateComponentButtonLabel().toString()}
                disabled={this.isButtonDisabled()}
                onClick={() => this.donate()}
                className={styleSheet.actionButton}
            />,
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
    }
}
